import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Message } from '../../../../../../../components'
import { TextInput } from '../../../../../../../components/shared'
import { THEMES } from '../../../../../../../utils'

/**
 * Info Modal
 * @param onClose
 * @return {*}
 * @constructor
 */
const InfoModal = ({ onClose }) => {
  return (
    <Message
      visible={true}
      type='info'
      title='Quality Rating'
      message={
        '<p>Q4\'s Quality Rating (QR) is a proprietary scoring system based upon a 0-100 scale, where 100 represents the \'Highest Quality\' firm/fund. These scores are calculated quarterly and are quantitatively-driven, taking subjectivity and human bias out of the equation. Amongst other things an investor\'s QR score is determined by examining its: Size (AUMs), Average Holding Period, Management Style, Number of Holdings, Turnover, and Distribution.</p>'
      }
      useHtml={true}
      onClose={onClose}
      renderExitButton={true}
      buttons={[{
        ui: 'citrus',
        label: 'Ok',
        onClick: onClose
      }]}
    />
  )
}

/**
 * Quality Rating Filter
 */
class QualityRating extends PureComponent {

  /**
   * On Min Value Change
   * @param event
   */
  onMinChange = (event) => {
    const { value } = this.props
    const minValue = event.currentTarget.value
    const maxValue = value && value[1]

    this.onChange([minValue, maxValue])
  }

  /**
   * On Max Value Change
   * @param event
   */
  onMaxChange = (event) => {
    const { value } = this.props
    const maxValue = event.currentTarget.value
    const minValue = value && value[0]

    this.onChange([minValue, maxValue])
  }

  /**
   * Wrapper for onchange with validation on fly
   * @param value
   */
  onChange = (value) => {
    const { onChange, onValidate } = this.props
    const ret = this.validate(false, value)
    onValidate && onValidate(ret)
    onChange(value)
  }

  /**
   * Restrict special characters
   * @param event
   */
  onKeyDown = (event) => {
    const restrictedKeys = [109, 189, 187]
    const keyCode = event.which || event.keyCode

    if (restrictedKeys.includes(keyCode)) {
      event.preventDefault()
    }
  }

  /**
   * Show Info Modal
   */
  onInfoClick = () => {
    const { openModal } = this.props
    openModal({
      component: InfoModal
    })
  }

  /**
   * Validation
   * @return {boolean}
   */
  validate = (throwError = true, formValue = null) => {
    const { onError } = this.props
    const value = formValue || this.props.value
    const minValue = parseInt(value[0], 0)
    const maxValue = parseInt(value[1], 0)

    if (minValue > 100 || minValue < 0) {
      throwError && onError('Min value must be between 0-100')
      return false
    }

    if (maxValue > 100 || maxValue < 0) {
      throwError && onError('Max value must be between 0-100')
      return false
    }

    if (minValue > maxValue && !isNaN(maxValue)) {
      throwError && onError('Min value cannot be greater than the max')
      return false
    }

    onError(null)
    return true
  }

  /**
   * Render
   * @return {*}
   */
  render () {
    const { value, error } = this.props
    const min = (value && value[0]) || ''
    const max = (value && value[1]) || ''

    return (
      <div className='field field--text field--coupled'>
        <label className='field_label'>
          Quality Rating
          <span className='button--info button--soft-grey' onClick={this.onInfoClick}/>
        </label>
        <div className='field_set'>
          <TextInput
            type='number'
            min={0}
            max={100}
            value={min}
            error={error}
            placeholder='0 (min)'
            autoComplete='false'
            onChange={this.onMinChange}
            onKeyDown={this.onKeyDown}
            onBlur={this.validate}
            theme={THEMES.WHITE}
          />
          <TextInput
            type='number'
            min={0}
            max={100}
            value={max}
            error={error}
            placeholder='100 (max)'
            autoComplete='false'
            onChange={this.onMaxChange}
            onKeyDown={this.onKeyDown}
            onBlur={this.validate}
            theme={THEMES.WHITE}
          />
        </div>
        {error && (
          <div className='field_error'>
            {error}
          </div>
        )}
      </div>
    )
  }
}

QualityRating.propTypes = {
  value: PropTypes.array.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValidate: PropTypes.func,
  openModal: PropTypes.func.isRequired
}

export default QualityRating
